import React, { useState } from "react";
import {
  SiFlutter, SiDart, SiFirebase, SiAndroidstudio, SiSupabase,
  SiXcode, SiGradle, SiArduino, SiNextdotjs, SiPostgresql,
  SiPostman, SiFigma, SiVisualstudiocode,
} from "react-icons/si";
import { DiJavascript1, DiReact, DiNodejs, DiPython, DiGit, DiJava } from "react-icons/di";
import { CgCPlusPlus } from "react-icons/cg";
import { FaAws, FaApple, FaGooglePlay, FaMobileAlt } from "react-icons/fa";
import { MdArchitecture } from "react-icons/md";

const categories = [
  {
    id: "mobile",
    icon: "📱",
    title: "Mobile Development",
    accent: "#54c5f8",
    skills: [
      { icon: <SiFlutter style={{ color: "#54c5f8" }} />,    name: "Flutter",          note: "2+ yrs, production" },
      { icon: <SiDart    style={{ color: "#0175c2" }} />,    name: "Dart",             note: "Primary language" },
      { icon: <FaMobileAlt style={{ color: "#a78bfa" }} />,  name: "React Native",     note: "Cross-platform" },
      { icon: <DiJava    style={{ color: "#f89820" }} />,    name: "Java",             note: "Android native" },
    ],
  },
  {
    id: "ios",
    icon: "🍎",
    title: "iOS & App Store Lifecycle",
    accent: "#f8f8f8",
    highlight: true,
    skills: [
      { icon: <FaApple   style={{ color: "#e0e0e0" }} />,    name: "iOS SDK",          note: "Xcode, CocoaPods, frameworks" },
      { icon: <SiXcode   style={{ color: "#1575f9" }} />,    name: "App Store Connect",note: "Submission, Review, compliance" },
      { icon: <FaApple   style={{ color: "#4ade80" }} />,    name: "TestFlight",       note: "Beta distribution" },
      { icon: <FaApple   style={{ color: "#f59e0b" }} />,    name: "Provisioning",     note: "Profiles, signing certs" },
    ],
    description: "Owned end-to-end iOS lifecycle at TanAinent — Xcode setup → CocoaPods → provisioning profiles → TestFlight → Apple Review (resolved FCM policy queries) → live App Store launch.",
  },
  {
    id: "android",
    icon: "🤖",
    title: "Android & Play Store",
    accent: "#3ddc84",
    skills: [
      { icon: <SiAndroidstudio style={{ color: "#3ddc84" }} />, name: "Android SDK",   note: "SDK, NDK, lifecycle" },
      { icon: <SiGradle  style={{ color: "#02303a" }} />,    name: "Google Play Console", note: "Staged rollouts, signing" },
      { icon: <FaGooglePlay style={{ color: "#01875f" }} />, name: "App Signing",      note: "Release tracks, policies" },
    ],
    description: "Managed full Play Console pipeline: app signing, internal → closed → production release tracks, staged rollouts, and policy compliance. App reached 4000+ downloads, 4.2★.",
  },
  {
    id: "backend",
    icon: "🔥",
    title: "Backend & Databases",
    accent: "#ffca28",
    skills: [
      { icon: <SiFirebase style={{ color: "#ffca28" }} />,   name: "Firebase",         note: "Auth, Firestore, FCM" },
      { icon: <SiSupabase style={{ color: "#3ecf8e" }} />,   name: "Supabase",         note: "PostgreSQL + Auth" },
      { icon: <FaAws      style={{ color: "#ff9900" }} />,   name: "AWS",              note: "EC2, S3, Lambda" },
      { icon: <DiNodejs   style={{ color: "#6cc24a" }} />,   name: "REST APIs",        note: "Design & integration" },
      { icon: <SiPostgresql style={{ color: "#336791" }} />, name: "PostgreSQL",       note: "Relational DB" },
    ],
  },
  {
    id: "arch",
    icon: "🏗️",
    title: "Architecture & Patterns",
    accent: "#a78bfa",
    skills: [
      { icon: <MdArchitecture style={{ color: "#a78bfa" }} />, name: "Clean Architecture", note: "Feature-first" },
      { icon: <MdArchitecture style={{ color: "#67e8f9" }} />, name: "BLoC / Cubit",     note: "State management" },
      { icon: <MdArchitecture style={{ color: "#f59e0b" }} />, name: "GetX",             note: "State + routing" },
      { icon: <MdArchitecture style={{ color: "#4ade80" }} />, name: "MVVM",             note: "UI / business separation" },
      { icon: <MdArchitecture style={{ color: "#fb923c" }} />, name: "SOLID Principles", note: "Design discipline" },
    ],
  },
  {
    id: "web",
    icon: "🌐",
    title: "Web & Languages",
    accent: "#f0db4f",
    skills: [
      { icon: <DiJavascript1 style={{ color: "#f0db4f" }} />, name: "JavaScript",      note: "ES6+" },
      { icon: <DiReact       style={{ color: "#61dafb" }} />, name: "React",           note: "Hooks, SPA" },
      { icon: <SiNextdotjs   style={{ color: "#fff" }} />,    name: "Next.js",         note: "Docs sites" },
      { icon: <DiPython      style={{ color: "#3776ab" }} />, name: "Python",          note: "ML, Flask" },
      { icon: <CgCPlusPlus   style={{ color: "#00599c" }} />, name: "C/C++",           note: "Algorithms" },
    ],
  },
  {
    id: "ar",
    icon: "🔮",
    title: "AR / Hardware / IoT",
    accent: "#06b6d4",
    skills: [
      { icon: <span style={{ fontSize: "1rem" }}>🔮</span>,  name: "ARCore",           note: "Platform channels, 3D" },
      { icon: <SiArduino style={{ color: "#00979d" }} />,    name: "Arduino / ESP32",  note: "ESP32, ESP8266, HC-05" },
      { icon: <span style={{ fontSize: "1rem" }}>📡</span>,  name: "UDP / Bluetooth",  note: "Wireless transport" },
    ],
  },
  {
    id: "tools",
    icon: "🛠️",
    title: "Tools & DevOps",
    accent: "#f97316",
    skills: [
      { icon: <SiAndroidstudio style={{ color: "#3ddc84" }} />, name: "Android Studio", note: "Primary IDE" },
      { icon: <SiXcode style={{ color: "#1575f9" }} />,      name: "Xcode",            note: "iOS development" },
      { icon: <SiVisualstudiocode style={{ color: "#007acc" }} />, name: "VS Code",     note: "General dev" },
      { icon: <DiGit    style={{ color: "#f05032" }} />,     name: "Git / GitHub",     note: "Version control" },
      { icon: <SiPostman style={{ color: "#ff6c37" }} />,    name: "Postman",          note: "API testing" },
      { icon: <SiFigma  style={{ color: "#f24e1e" }} />,     name: "Figma",            note: "UI/UX design" },
    ],
  },
];

function SkillsSection() {
  const [active, setActive] = useState(null);

  return (
    <section id="skills" className="sp-section sp-section-alt">
      <div className="sp-container">
        <div className="sp-section-header">
          <span className="section-label">What I know</span>
          <h2 className="section-title">
            Technical <span className="gradient-text">Skills</span>
          </h2>
          <p className="section-subtitle">
            From publishing iOS apps on the App Store to building AR experiences &amp; IoT hardware — full lifecycle, full stack.
          </p>
        </div>

        <div className="skills-grid">
          {categories.map((cat) => (
            <div
              key={cat.id}
              className={`skill-cat-card${cat.highlight ? " skill-cat-highlight" : ""}${active === cat.id ? " skill-cat-active" : ""}`}
              style={{ "--cat-accent": cat.accent }}
              onMouseEnter={() => setActive(cat.id)}
              onMouseLeave={() => setActive(null)}
            >
              {/* Top bar */}
              <div className="skill-cat-bar" style={{ background: cat.accent }} />

              <div className="skill-cat-head">
                <span className="skill-cat-emoji">{cat.icon}</span>
                <span className="skill-cat-title" style={{ color: cat.accent }}>
                  {cat.title}
                </span>
              </div>

              {/* Description if exists */}
              {cat.description && (
                <p className="skill-cat-desc">{cat.description}</p>
              )}

              {/* Skill rows */}
              <div className="skill-rows">
                {cat.skills.map(({ icon, name, note }) => (
                  <div className="skill-row" key={name}>
                    <div className="skill-row-left">
                      <span className="skill-row-icon">{icon}</span>
                      <span className="skill-row-name">{name}</span>
                    </div>
                    <span className="skill-row-note">{note}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SkillsSection;
